<template>
    <div class="issueItemContentWrap">
      <div class="subject">
        <strong>{{item.title}}</strong>
      </div>
      <div class="content">
        <p>{{item.content}}</p>
      </div>
      <div class="imageListWrap">
        <div class="imageWrap"
             v-for="(imgUrl , index) in item.savedFiles">
          <img :src="'//' + item.savedUrl+imgUrl">
        </div>
      </div>
      <!--{{item}}-->
    </div>
</template>

<script>
    export default {
        name: "issue-item-modal-content" ,
        props : ['item'],
    }
</script>

<style scoped lang="scss">
  .issueItemContentWrap{
    width:80%;
    margin:0 auto;
    .subject {
      text-align: center;
      >strong {
        font-size:1.6rem;
      }
    }
    .content {
      >p {
        color:#292929;
        font-weight:300;
      }

    }
    .imageListWrap{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .imageWrap{
        width:100%;
        height:100%;
        >img {
          width:100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/IssueItemModalContent.vue